
import {observable} from "mobx";
import { PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {ControlTypeEnum} from "PageBuilder/pagebuilder/Controls/NormalPDFControlFactory";


export class FieldControlOptions extends PDFControlBaseOptions{
    Type:ControlTypeEnum;
    FieldId:string;
    @observable
    Label:string;
    @observable
    LabelPosition:LabelPositionEnum;
    SubType:string;
    Style:string;

    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.FieldId='';
        this.Label='';
        this.Style='simple';
        this.Type=ControlTypeEnum.Field;
        this.Styles.Width='180px';
        this.LabelPosition=LabelPositionEnum.Top;
        this.SubType='';
    }
}

export enum LabelPositionEnum{
    Top='Top',
    Bottom='Bottom',
    Lef='Left',
    Right='Right'
}